import { render, staticRenderFns } from "./CompanyDelete.vue?vue&type=template&id=3667ef1c&scoped=true&"
import script from "./CompanyDelete.vue?vue&type=script&lang=ts&"
export * from "./CompanyDelete.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDelete.vue?vue&type=style&index=0&id=3667ef1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3667ef1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VCard,VContainer,VIcon})
